/**
 * @prettier
 */

import React from 'react';
import cx from 'classnames';
import { getImageUrl } from '../../../../util/imageHelper';
import { ptToPx } from '../../../../util';
import { usePhotoObjectURL } from '../util/hooks';
import styles from './styles.module.less';

const ImageElement = ({
  element,
  border = false,
  pixelCrop = undefined,
  photo = undefined,
  uploadcareFile = undefined,
  className = undefined,
  isRounded = false,
  isFolded = false,
}) => {
  const photoURL = usePhotoObjectURL(photo);

  if (!element) {
    return null;
  }

  const { customizable, overlay, layer = 0 } = element;
  const isFoldedCardElement = isFolded && !customizable && !overlay;

  const elemHight = isFoldedCardElement ? element.height / 2 : element.height;

  const divStyle = {
    zIndex: layer,
    left: `${element.x}pt`,
    top: isFoldedCardElement ? `${elemHight}pt` : `${element.y}pt`,
    width: `${element.width}pt`,
    height: `${elemHight}pt`,
  };

  let imgURL;
  const croppedImageStyle = {};

  if (uploadcareFile) {
    // Uploadcare image
    imgURL = uploadcareFile.cdnUrl;
  } else if (photo && photo.valid && pixelCrop && photoURL) {
    // Blob image
    const { filledSize } = photo;

    const backgroundScale = {
      w: ptToPx(element.width) / filledSize,
      h: ptToPx(elemHight) / filledSize,
    };

    const cropScale = { w: filledSize / pixelCrop.width, h: filledSize / pixelCrop.height };

    const offset = {
      x: -pixelCrop.x * backgroundScale.w * cropScale.w,
      y: -pixelCrop.y * backgroundScale.h * cropScale.h,
    };

    croppedImageStyle.backgroundPosition = `${offset.x}px ${offset.y}px`;
    croppedImageStyle.backgroundSize = `${Math.round(100 * cropScale.w)}%`;

    imgURL = photoURL;
  } else {
    // Default element image
    imgURL = getImageUrl(element.image_id);
  }

  croppedImageStyle.backgroundImage = `url(${imgURL})`;
  croppedImageStyle.backgroundPosition = isFoldedCardElement ? 'bottom' : '';

  return (
    <div
      className={cx(styles.imageLayer, className, {
        [styles.rounded]: isRounded,
        [styles.border]: border,
      })}
      style={{ ...divStyle, ...croppedImageStyle }}
    />
  );
};

export default ImageElement;
